import React from 'react';

export default function ModeSelector({ lang, onSelectMode }) {
  return (
    <div className="mode-selector">
      <div className="mode-title">
        🚔 AI Police Platform
      </div>
      <div className="mode-subtitle">
        {lang === 'nl'
          ? 'Selecteer uw toegangsniveau'
          : 'Select your access level'}
      </div>
      <div className="mode-cards">
        <div className="mode-card" onClick={() => onSelectMode('agent')}>
          <div className="mode-card-icon">👮</div>
          <div className="mode-card-title">
            {lang === 'nl' ? 'Agent Modus' : 'Agent Mode'}
          </div>
          <div className="mode-card-desc">
            {lang === 'nl'
              ? '13 werkprocessen • PV\'s • Verhoren • Dossiers • Signaleringen • Briefings'
              : '13 workflows • Reports • Interviews • Case files • Alerts • Briefings'}
          </div>
        </div>
        <div className="mode-card" onClick={() => onSelectMode('burger')}>
          <div className="mode-card-icon">🏛️</div>
          <div className="mode-card-title">
            {lang === 'nl' ? 'Burger Modus' : 'Citizen Mode'}
          </div>
          <div className="mode-card-desc">
            {lang === 'nl'
              ? 'Aangifte doen • Rechten & Plichten • Cybercrime hulp • Slachtofferhulp'
              : 'File reports • Rights & Duties • Cybercrime help • Victim support'}
          </div>
        </div>
      </div>
    </div>
  );
}
